import {SupportedLang} from '@/app/core/models/supportedLang';

export interface Article {
	id: string;
	createdAt: Date;
	thumbnailImageKey: string;
	imageKey: string;
	articleType: ArticleType;
	translations: Record<SupportedLang, ArticleTranslation>;
	twitterUrl?: string;
}

export interface ArticleWithNavigation {
	previousArticleId?: string;
	nextArticleId?: string;
	article: Article;
}

export interface ArticleTiny {
	id:string;
	thumbnailImageKey:string;
	translations: Record<SupportedLang, ArticleTranslation>;
}

export enum ArticleType {
	OVERWATCH = 'OVERWATCH',
	MARVEL_RIVALS = 'MARVEL_RIVALS',
	TEAM_PEPS = 'TEAM_PEPS',
	POKEMON_VGC = 'POKEMON_VGC',
	POKEMON_UNITE = 'POKEMON_UNITE',
	DOFUS = 'DOFUS',
}

export interface ArticleTranslation {
	title: string;
	content: string;
}
